import { numberToAlphabet } from '../../../utils';

export const PollResultLabel = ({ index }: { index: number }) => (
    <span className="w-8 h-8 flex-none border-2 border-poll-gray rounded-full inline-flex justify-center items-center capitalize font-medium mr-3">
        {numberToAlphabet(index)}
    </span>
);
